import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import InfiniteDropdownMenu from '../../../../../components/InfiniteDropdownMenu';
import {
  getCompanyDepartments,
  selectCompanyDepartments,
  selectCompanyDepartmentsPageInfo
} from '../../../../../redux/modules/company';
import { selectCurrentDepartment, setCurrentDepartment } from '../../../../../redux/modules/emails';

function CompanyDepartmentsDropdown({
  onSelect = () => {}
}) {
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const companyDepartments = useSelector(selectCompanyDepartments);
  const companyDepartmentsPageInfo = useSelector(selectCompanyDepartmentsPageInfo);
  const selectedDepartment = useSelector(selectCurrentDepartment);

  const fetchMoreCompanyDepartments = () => {
    dispatch(getCompanyDepartments(
      companyId,
      {
        pageSize: 50,
        pageNumber: companyDepartmentsPageInfo.currentPage + 1
      }
    ));
  };

  const onDepartmentSelect = dept => {
    onSelect(dept);
    dispatch(setCurrentDepartment(dept));
  };

  return (
    <InfiniteDropdownMenu
      data={companyDepartments}
      fetchMoreData={fetchMoreCompanyDepartments}
      idKey="departmentId"
      initialSelect={{
        id: selectedDepartment.departmentId,
        label: selectedDepartment.departmentName,
        ...selectedDepartment
      }}
      labelKey="departmentName"
      pageInfo={companyDepartmentsPageInfo}
      scrollClassName="departmentOptionsPopoverMenu"
      onSelect={dept => onDepartmentSelect(dept)}
    />
  );
}

CompanyDepartmentsDropdown.propTypes = {
  onSelect: PropTypes.func
};

export default CompanyDepartmentsDropdown;
